import {
  GET_DEALTAG,
  GET_DEALTAG_SUCCESS,
  GET_DEALTAG_FAIL,
  DELETE_DEALTAG,
  DELETE_DEALTAG_SUCCESS,
  DELETE_DEALTAG_FAIL,
  UPDATE_DEALTAG,
  UPDATE_DEALTAG_SUCCESS,
  UPDATE_DEALTAG_FAIL,
  ADD_NEW_DEALTAG,
  ADD_DEALTAG_SUCCESS,
  ADD_DEALTAG_FAIL,
  DEALTAG_LOADING,
  DEALTAG_RESET,
} from "./actionType";

export const resetDealTagState = (actionType) => ({
  type: DEALTAG_RESET,
  payload: { actionType },
});

export const getDealTagSuccess = (actionType, data) => ({
  type: GET_DEALTAG_SUCCESS,
  payload: { actionType, data },
});

export const getDealTagFail = (actionType, error) => ({
  type: GET_DEALTAG_FAIL,
  payload: { actionType, error },
});

export const getDealTag = (data) => ({
  type: GET_DEALTAG,
  payload: data,
});

export const getDealTagLoading = () => ({
  type: DEALTAG_LOADING,
});

export const deleteDealTag = (data) => ({
  type: DELETE_DEALTAG,
  payload: data,
});

export const deleteDealTagSuccess = (data) => ({
  type: DELETE_DEALTAG_SUCCESS,
  payload: data,
});

export const deleteDealTagFail = (error) => ({
  type: DELETE_DEALTAG_FAIL,
  payload: error,
});

export const updateDealTag = (data) => ({
  type: UPDATE_DEALTAG,
  payload: data,
});

export const updateDealTagFail = (error) => ({
  type: UPDATE_DEALTAG_FAIL,
  payload: error,
});

export const updateDealTagSuccess = (data) => ({
  type: UPDATE_DEALTAG_SUCCESS,
  payload: data,
});

export const addNewDealTag = (data) => ({
  type: ADD_NEW_DEALTAG,
  payload: data,
});

export const addDealTagSuccess = (data) => ({
  type: ADD_DEALTAG_SUCCESS,
  payload: data,
});

export const addDealTagFail = (error) => ({
  type: ADD_DEALTAG_FAIL,
  payload: error,
});
